export const upsellComparison = [
  {
    sit: 'Preparar clases técnicas avanzadas',
    sin: 'Buscás horas sin encontrar nivel suficiente',
    con: 'Genómica predictiva, IA forense, reconstrucción 3D y DDHH listos para usar',
  },
  {
    sit: 'Explicar la Criminalística moderna en profundidad',
    sin: 'Tenés datos básicos pero no el análisis completo',
    con: 'Historia completa, tecnología de punta y contexto ético integrado',
  },
  {
    sit: 'Hablar de ciberdelitos con autoridad',
    sin: 'Explicás lo básico pero no las implicancias legales reales',
    con: 'Análisis técnico-legal completo de cada tipo de ciberdelito',
  },
  {
    sit: 'Responder el debate IA-justicia',
    sin: 'Datos parciales sin profundidad argumentativa',
    con: 'Argumentos técnicos de todos los ángulos con evidencia científica real',
  },
  {
    sit: 'Proyectar el futuro de la Criminalística',
    sin: 'No tenés base para hablar de tendencias 2026',
    con: 'Tendencias internacionales, Argentina en el mundo forense, escenarios 2030',
  },
  {
    sit: 'Posicionarte como docente de vanguardia',
    sin: 'Tu material es el mismo que el de todos',
    con: 'Enseñás lo que ningún libro de texto del sector tiene todavía',
  },
]

export interface UpsellModule {
  title: string
  items: Array<{ title: string; desc: string }>
}

export const upsellModules: UpsellModule[] = [
  {
    title: '🚀 UPSELL 1 — Criminalística Avanzada y Ciencias Forenses 2026',
    items: [
      {
        title: 'Genómica Forense Predictiva',
        desc: 'Más allá de identificar al autor: estimar su apariencia física a partir del ADN sin muestra de comparación. Qué puede hacer el BNDG en 2026 que era imposible hace 5 años y por qué esto cambia radicalmente la investigación de personas no identificadas.',
      },
      {
        title: 'Inteligencia Artificial en la Investigación Criminal',
        desc: 'Reconocimiento facial: precisión real, sesgos documentados y el debate constitucional argentino. Análisis predictivo del crimen: cómo funciona, qué resultados produce y por qué puede criminalizar la pobreza. El estándar argentino 2026 para IA como evidencia.',
      },
      {
        title: 'Reconstrucción 3D y Realidad Virtual en el Tribunal',
        desc: 'Escaneo 3D obligatorio en homicidios federales desde 2026: qué es una nube de puntos, cómo se usa en juicio oral y qué significa que el juez pueda "recorrer" la escena del hecho virtualmente años después del crimen.',
      },
      {
        title: 'Ciberforense de Alta Complejidad',
        desc: 'Dark web, criptomonedas y blockchain como evidencia, deepfakes en juicio, stalkerware y violencia de género digital, IoT como testigo. Los casos que los manuales no tienen y que el sistema judicial argentino ya está procesando.',
      },
      {
        title: 'Pericias en Casos de Derechos Humanos',
        desc: 'El rol del EAAF como referente mundial: 40 años identificando víctimas de dictaduras en todo el planeta. Cómo la Criminalística argentina se convirtió en herramienta de justicia transicional y qué modelos exporta al mundo.',
      },
    ],
  },
  {
    title: '🚀 UPSELL 2 — Docente Experto en Criminalística Argentina',
    items: [
      {
        title: 'El Sistema Docente Elite',
        desc: 'La diferencia entre el docente que enseña bien y el docente que forma peritos. Las cinco dimensiones del conocimiento experto. Cómo construir un sistema que funciona sin depender de la inspiración del momento.',
      },
      {
        title: 'Construcción de Autoridad Nacional',
        desc: 'Los cinco activos de autoridad del docente referente. Estrategia de contenido digital para LinkedIn, YouTube y newsletter. Cómo posicionarse como la voz más calificada en la enseñanza de la Criminalística en tu ámbito.',
      },
      {
        title: 'Formación de Formadores: El Efecto Multiplicador',
        desc: 'Un docente impacta 30 alumnos por año. Un docente que forma a 10 docentes impacta 300 sin estar presente. El programa completo de 20 horas para capacitar a otros docentes de Criminalística.',
      },
      {
        title: 'Investigación-Acción Pedagógica',
        desc: 'Cómo convertirte en productor de conocimiento, no solo consumidor. Sistematización de experiencias, publicación de materiales, participación en congresos. El camino del docente que define el estándar de la disciplina.',
      },
      {
        title: 'Plan de Desarrollo 2026–2028',
        desc: 'Diagnóstico de punto de partida. Tres metas concretas de desarrollo. Calendario de acción mes a mes. El plan que convierte la intención en resultado.',
      },
    ],
  },
]

export const packIncluded = [
  '✅ TOMO 1: Fundamentos de la Criminalística',
  '✅ TOMO 2: Inspección Ocular y Escena del Hecho',
  '✅ TOMO 3: Evidencias Físicas y Laboratorio Forense',
  '✅ TOMO 4: Técnicas Periciales Aplicadas',
  '✅ TOMO 5: Investigación Criminal Moderna 2026',
  '✅ TOMO 6: Didáctica de la Criminalística',
  '🎁 BONO 1: Banco de 300 Evaluaciones de Criminalística',
  '🎁 BONO 2: 100 Casos Criminalísticos para el Aula',
  '🎁 BONO 3: Kit Profesional del Docente Criminalista',
  '🎁 BONO 4: Banco de Recursos Visuales 2026',
  '✅ Acceso de por vida',
  '✅ Actualizaciones gratuitas',
]

export const upsellIncluded = [
  '🚀 UPSELL 1 — CRIMINALÍSTICA AVANZADA Y CIENCIAS FORENSES 2026: Genómica predictiva, análisis forense de IA, reconstrucción 3D avanzada, ciberforense de alta complejidad, pericias en delitos de DDHH, cooperación internacional INTERPOL',
  '🚀 UPSELL 2 — DOCENTE EXPERTO EN CRIMINALÍSTICA ARGENTINA: Sistema docente elite, construcción de autoridad, formación de formadores, investigación-acción pedagógica, plan de desarrollo 2026–2028',
]
